import {
  CreateApplicationGroupDto,
  SearchApplicationGroupResultDto,
  UpdateApplicationGroupDto,
} from 'switch-shared/modules/crud/application-group/application-group.dto';
import { ApplicationGroup } from 'switch-shared/modules/crud/application-group/application-group.entity';

import { baseAPI } from './baseAPI.service';
import { API_METHODS, ENDPOINT_URLS } from './config/apiTags';

export const applicationGroupAPI = baseAPI
  .enhanceEndpoints({
    addTagTypes: [ENDPOINT_URLS.APPLICATION_GROUP],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getApplicationGroupById: builder.query<ApplicationGroup, string>({
        query: (id) => `${ENDPOINT_URLS.APPLICATION_GROUP}/${id}`,
        providesTags: (_res, _err, id) => [
          { type: ENDPOINT_URLS.APPLICATION_GROUP, id },
        ],
      }),

      getAllApplicationGroups: builder.query<
        SearchApplicationGroupResultDto,
        any
      >({
        query: (params) => {
          return {
            url: `${ENDPOINT_URLS.APPLICATION_GROUP}`,
            params,
          };
        },
        providesTags: (res, _err, _) =>
          res?.data.map((con) => ({
            type: ENDPOINT_URLS.APPLICATION_GROUP,
            id: con._id,
          })) ?? [],
      }),

      createApplicationGroup: builder.mutation<
        ApplicationGroup,
        CreateApplicationGroupDto
      >({
        query: (data) => ({
          url: `${ENDPOINT_URLS.APPLICATION_GROUP}`,
          method: API_METHODS.POST,
          body: data,
        }),
        invalidatesTags: [ENDPOINT_URLS.APPLICATION_GROUP],
      }),

      updateApplicationGroup: builder.mutation<
        ApplicationGroup,
        { id: string; data: UpdateApplicationGroupDto }
      >({
        query: ({ id, data }) => ({
          url: `${ENDPOINT_URLS.APPLICATION_GROUP}/${id}`,
          method: API_METHODS.PATCH,
          body: data,
        }),
        invalidatesTags: (_res, _err, { id }) => [
          {
            type: ENDPOINT_URLS.APPLICATION_GROUP,
            id,
          },
        ],
      }),

      deleteApplicationGroup: builder.mutation<{ success: boolean }, string>({
        query: (id) => ({
          url: `${ENDPOINT_URLS.APPLICATION_GROUP}/${id}`,
          method: API_METHODS.DELETE,
        }),
        invalidatesTags: (_res, _err, id) => [
          {
            type: ENDPOINT_URLS.APPLICATION_GROUP,
            id,
          },
        ],
      }),
    }),
  });

export const {
  useGetApplicationGroupByIdQuery,
  useGetAllApplicationGroupsQuery,
  useLazyGetAllApplicationGroupsQuery,
  useCreateApplicationGroupMutation,
  useUpdateApplicationGroupMutation,
  useDeleteApplicationGroupMutation,
} = applicationGroupAPI;
export default applicationGroupAPI;
